import React, { useState, useEffect, useMemo, useRef } from "react";
import BasicCard from "../../components/InvoiceCard/Card";
import Box from "@mui/material/Box";
import { Grid, Input } from "@mui/material";
import classNames from "classnames";
import Popover from "@mui/material/Popover";
import IconButton from "@mui/material/IconButton";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";

import { useQuery, gql } from "@apollo/client";
import {
  CUSTOMER_SEARCH,
  FETCH_ALL_CONTRACTS,
  FETCH_ALL_CUSTOMERS,
  FETCH_ALL_DOCUMENTS,
  FETCH_ALL_INVOICES,
  FETCH_CURRENT_USER,
  FETCH_CUSTOMERS,
  FETCH_USER_VENDOR_DETAIL,
  FETCH_VENDOR_WORK_ORDERS,
} from "../../GraphQL/Queries";

// File Uploader
import { FileUploader } from "react-drag-drop-files";

//DateRange
import { DateRangePicker } from "react-date-range";
import { addDays } from "date-fns";

import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

//Styles

import useStyles from "./styles";
import PageTitle from "../../components/PageTitle/PageTitle";
import { Button, TextField } from "@material-ui/core";

//Icons and other imports

import Calendar from "../../assets/img/icons/calendar.svg";
import open_invoice from "../../assets/img/icons/open_invoice.svg";
import Closed_Invoice from "../../assets/img/icons/Closed_Invoice.svg";
import FilterIcon from "../../assets/img/icons/filter.svg";
import CardPage from "../../assets/img/menu/CardPage.svg";
import Plus from "../../assets/img/icons/plus.svg";
import AddInvoiceForm from "../invoices/components/forms/AddInvoiceForm";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, withRouter } from "react-router-dom";
import {
  getContractsData,
  getDocumentsData,
  getInvoicesData,
  getUserVendorDetails,
  getVendorWorkOrderData,
} from "../../redux/actions/invoiceActions";
import Filter from "../../components/Filter/Filter";
import AddMicroInvoiceForm from "../invoices/components/forms/AddMicroInvoiceForm";
import { getCurrentUser } from "../../redux/actions/authActions";
import Tabs from "../invoices/components/Tabs";
import AddDocumentForm from "../invoices/components/forms/AddDocumentForm";
import AddCustomerForm from "../invoices/components/forms/AddCustomerForm";
import AddEquipmentForm from "../invoices/components/forms/AddEquipmentForm";
import { getAllCustomerInvoiceStatus, getAllVendorStatus } from "../../helpers";
import CardContent from "../invoices/components/cardContent/CardContent";
import moment from "moment";

// File Types to be uploaded

const fileTypes = ["JPG", "PNG", "GIF"];

export default function WorkOrders(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const buttonRef = useRef(null);
  function Query() {
    const { search } = useLocation();
    const history = useHistory();

    return useMemo(() => new URLSearchParams(search), [search]);
  }
  // http://localhost:3000/#/token?token=eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoyNn0.8ge4LVsGTv__q_urNjS1w5trQWIUG6DDt-x65t48AQY#/login
  let query = Query();

  let queryValue = query.get("modal");

  console.log(window.location.href, "locnacka");
  const [icon, setIcon] = React.useState(null);
  const [tabsparentState, settabsParentState] = useState("Vendor Invoices");
  const [openModal, setOpenModal] = React.useState(false);
  const [filterApply, setFilterApply] = React.useState(false);
  const [filterName, setFilterName] = React.useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [focus, setFocus] = React.useState(false);
  const [search, setSearch] = useState();
  const [vendorSearch, setVendorSearch] = useState();
  const [invoiceSearch, setInvoiceSearch] = useState();
  const [searchBy, setSearchBy] = useState("Customer Name");
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState([]);
  const [location, setLocation] = useState([]);
  const [city, setCity] = useState([]);
  const [invoiceType, setInvoiceType] = useState([]);
  const [workOrderStatusForFilter, setWorkOrderStatusForFilter] = useState([]);
  const [workOrderLocationsForFilter, setWorkOrderLocationsForFilter] =
    useState([]);
  const [invoicesDataForFilter, setInvoicesStatusForFilter] = useState([]);
  const [invoiceTypeForFilter, setInvoiceTypeForFilter] = useState([]);
  const [date, setDate] = useState([
    {
      startDate: "",
      endDate: "",
      key: "selection",
    },
  ]);

  // console.log(queryValue, icon, "bcbasc");

  // Use Selector to get the data from store
  /* istanbul ignore next */
  const authUserData = useSelector((state) => state?.auth?.authUserData);
  /* istanbul ignore next */
  const invoicesData = useSelector(
    (state) => state?.invoices?.getAllInvoicesData?.allInvoices,
  );
  /* istanbul ignore next */
  const contractsData = useSelector(
    (state) => state?.invoices?.getAllContractsData?.allContracts,
  );
  /* istanbul ignore next */
  const documentsData = useSelector(
    (state) => state?.invoices?.getAllDocumentsData?.allDocuments,
  );
  /* istanbul ignore next */
  const vendorInvoiceData = useSelector(
    (state) => state?.invoices?.getVendorInvoiceData?.vendorWorkOrder,
  );
  /* istanbul ignore next */
  const token = useSelector((state) => state?.auth?.authUserData?.token);
  const vendorId = useSelector(
    (state) => state?.auth?.authUserData?.user?.vendorId,
  );
  /* istanbul ignore next */
  const userId = useSelector((state) => state?.auth?.authUserData?.user?.id);
  /* istanbul ignore next */
  const userRole = useSelector(
    (state) => state?.auth?.authUserData?.user?.role,
  );

  // ------------------Queries Maintained ---------------------------//

  // Api call to fetch current user
  const {
    error: currentUserError,
    loading: currentUserLoading,
    data: user,
  } = useQuery(FETCH_CURRENT_USER, {
    variables: {
      token: token,
    },
  });

  // Api call to fetch  vendor detail
  const {
    error: userVendorError,
    loading: userVendorLoading,
    data: userVendorDetail,
  } = useQuery(FETCH_USER_VENDOR_DETAIL, {
    variables: {
      token: token,
      id: user?.currentUser?.vendorId,
    },
    skip: !user,
  });

  // Api call to fetch  vendor work orders
  const {
    error: searchCustomersErrors,
    loading: searchCustomersLoading,
    data: searchCustomers,
  } = useQuery(CUSTOMER_SEARCH, {
    variables: {
      token,
      search: search ? search : undefined,
    },
    skip: !userRole,
  });

  const customersArray = useSelector(state => state?.auth?.authUserData?.user?.customers) || [];
  console.log(customersArray, "customersArray");
  
  // Attempt to parse the array
  let customerIds;
  try {
    customerIds = JSON.parse(customersArray);
  } catch (error) {
    console.error('Error parsing JSON:', error);
    customerIds = [];
  }
  
  // Ensure it's an array
  if (!Array.isArray(customerIds)) {
    console.error('Error: customersArray is not an array');
    customerIds = [];
  } else {
    // Ensure all elements are valid integers
    customerIds = customerIds.map(id => parseInt(id, 10));
  
    // Filter out NaN values
    customerIds = customerIds.filter(id => !isNaN(id));
  }
  
  console.log(customerIds, "Customers");

  // Api call to fetch  vendor work orders

  /* istanbul ignore next */
  const {
    error: vendorWorkOrdersErrors,
    loading: vendorWorkOrdersLoading,
    data: vendorWorkOrders,
    refetch,
  } = useQuery(FETCH_VENDOR_WORK_ORDERS, {
    variables: {
      token,
      id: userRole === "vendor" ? vendorId : customerIds,
      startDate: date[0]?.startDate ? new Date(date[0]?.startDate) : undefined,
      endDate: date[0]?.endDate ? new Date(date[0]?.endDate) : undefined,
      status: filterApply && status?.length > 0 ? status : undefined,
      city:
        filterApply && location
          ? location
          : !filterApply && city
          ? city
          : undefined,
      query:
        searchBy === "Customer Name" && vendorSearch
          ? vendorSearch
          : undefined || (searchBy === "Invoice Number" && search)
          ? search
          : undefined,
      invoiceType:
        filterApply && invoiceType?.length > 0 ? invoiceType : undefined,
    },
    skip: !userRole,
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-first",
  });

  // Renderers Maintained

  // Rendering to save all the filters in a state
  /* istanbul ignore next */
  useEffect(() => {
    setWorkOrderStatusForFilter([
      ...new Set(vendorInvoiceData?.map((item) => item?.aasmState)),
    ]);
    setWorkOrderLocationsForFilter([
      ...new Set(vendorInvoiceData?.map((item) => item?.customer?.city)),
    ]);
    setInvoiceTypeForFilter([
      ...new Set(vendorInvoiceData?.map((item) => item?.invoiceType)),
    ]);
  }, [vendorInvoiceData]);

  // clear search on tabs change

  useEffect(() => {
    setSearch(null);
  }, [tabsparentState]);
  /* istanbul ignore next */
  useEffect(() => {
    if (queryValue === "newCustomers" && buttonRef.current) {
      buttonRef.current.click();
    }
    if (queryValue === "newWorkorder") {
      const syntheticEvent = {
        currentTarget: document,
      };
      handleClick(syntheticEvent, "microInvoice");
    }
  }, [query.get("modal")]);

  useEffect(() => {
    setStatus([]);
    setLocation([]);
    setInvoiceType([]);
    setDate([
      {
        startDate: "",
        endDate: "",
        key: "selection",
      },
    ]);
  }, [tabsparentState]);

  useEffect(() => {
    if (user) {
      dispatch(getCurrentUser(user, token, "!navigate"));
    }
  }, [user]);

  // use effect to grab and update all data from redux as soon as the api is called
  useEffect(() => {
    dispatch(getVendorWorkOrderData(vendorWorkOrders));
    dispatch(getUserVendorDetails(userVendorDetail));
  }, [vendorWorkOrders, userVendorDetail]);

  // Functions Maintained

  // apply filter function
  /* istanbul ignore next */
  const onFilterApply = () => {
    setFilterApply(true);
    setOpenModal(false);
  };

  // tabs change
  /* istanbul ignore next */
  function handleChildChange(childState) {
    settabsParentState(childState);
  }

  const handleChange = (file) => {
    setFile(file);
  };

  // handling popover
  /* istanbul ignore next */
  const handleClick = (event, type) => {
    setIcon(type);
    setAnchorEl(event.currentTarget);
  };

  /* istanbul ignore next */
  const handleSearchItemClick = (value) => {
    setFocus(false);
    setCity(value?.internalName);
    setSearch(value?.name + " " + value.internalName);
    setVendorSearch(value?.name);
  };

  /* istanbul ignore next */
  const clearAll = () => {
    setFocus(false);
    setCity("");
    setSearch("");
    setVendorSearch("");
  };

  //open Filter Modal
  /* istanbul ignore next */
  const handleFilterClick = (event, type) => {
    setOpenModal(true);
    setIcon(type);
    onReset();
    // setAnchorEl(event.currentTarget);
  };

  const handleFocus = (e) => {
    // dispatch(searchBooks(e.target.value, accessToken));
    setFocus(true);
  };

  /* istanbul ignore next */
  const onReset = () => {
    setStatus([]);
    setInvoiceType([]);
    setLocation([]);
    setFilterApply(false);
  };

  // set anchor tag null
  const handleClose = () => {
    setAnchorEl(null);
  };

  const vendorStatus = getAllVendorStatus();
  const customerInvoiceStatus = getAllCustomerInvoiceStatus();

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  //open PopOver Display
  const PopoverDisplay = () => {
    /* istanbul ignore next */
    return (
      <div>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorReference="anchorPosition"
          anchorPosition={{ top: 75, left: 850 }}
          anchorOrigin={{
            vertical: "center",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          {/* Calendar Popover */}

          {icon === "calendar" && (
            <>
              <div className={classNames(classes.modalContainer)}>
                <div className={classNames(classes.headerContainer)}>
                  <Box sx={{ margin: "24px 0 12px 0" }}>
                    <div>
                      <label>From</label>
                    </div>
                    <input
                      value={date[0]?.startDate}
                      onChange={(e) =>
                        setDate([{ ...date[0], startDate: e.target.value }])
                      }
                      type="month"
                      className={classes.textField}
                    />
                  </Box>
                  <Box sx={{ margin: "24px 0 12px 0" }}>
                    <div>
                      <label>To</label>
                    </div>
                    <input
                      value={date[0]?.endDate}
                      onChange={(e) =>
                        setDate([{ ...date[0], endDate: e.target.value }])
                      }
                      type="month"
                      className={classes.textField}
                    />
                  </Box>
                  <Box
                    sx={{
                      margin: "24px 0 24px 0",
                      display: "flex",
                      flexDirection: "row-reverse",
                    }}
                  >
                    <button
                      onClick={() =>
                        setDate([{ ...date[0], endDate: "", startDate: "" }])
                      }
                      className="upload_button"
                    >
                      Clear
                    </button>
                  </Box>
                </div>
              </div>
            </>
          )}
          {/* Upload Popover */}
          {icon === "upload" && (
            <>
              <div className={classNames(classes.modalContainer)}>
                <div className={classNames(classes.headerContainer)}>
                  <div className={classNames(classes.modalHeader)}>
                    Add Document
                  </div>
                </div>

                <div className={classNames(classes.headerContainer)}>
                  <Box sx={{ margin: "24px 0 12px 0" }}>
                    <div>
                      <label>Title</label>
                    </div>
                    <Input className={classes.textField} />
                  </Box>
                  <Box
                    sx={{
                      margin: "24px 0 12px 0",
                    }}
                  >
                    <div>
                      <label>Attach Document</label>
                    </div>
                    <Box className={"fileUploader"}>
                      <FileUploader
                        handleChange={handleChange}
                        name="file"
                        types={fileTypes}
                      />
                      <div>
                        <label className={classes.fileTypeText}>
                          Accepted File Types: .PDF and CSV only
                        </label>
                      </div>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      margin: "24px 0 24px 0",
                      display: "flex",
                      flexDirection: "row-reverse",
                    }}
                  >
                    <button className="upload_button">Upload</button>
                    <button className="cancel_button">Cancel</button>
                  </Box>
                </div>
              </div>
            </>
          )}
          {/* Create New Invoice popover*/}
          {icon === "microInvoice" && (
            <AddMicroInvoiceForm
              refetchWorkOrders={refetch}
              closeModal={handleClose}
              handleClick={handleClick}
            />
          )}

          {icon === "equipment" && (
            <AddEquipmentForm
              closeModal={handleClose}
              handleClick={handleClick}
            />
          )}
          {(icon === "customer" || queryValue == "addCustomer") && (
            <AddCustomerForm closeModal={handleClose} />
          )}
        </Popover>
      </div>
    );
  };

  /* istanbul ignore next */
  return (
    <>
      <Filter
        open={openModal}
        onClose={() => setOpenModal(false)}
        status={status}
        setStatus={setStatus}
        tabsparentState={tabsparentState}
        workOrderStatusForFilter={workOrderStatusForFilter}
        invoicesDataForFilter={invoicesDataForFilter}
        workOrderLocationsForFilter={workOrderLocationsForFilter}
        invoiceTypeForFilter={invoiceTypeForFilter}
        location={location}
        setLocation={setLocation}
        invoiceType={invoiceType}
        setInvoiceType={setInvoiceType}
        onFilterApply={onFilterApply}
        setFilterApply={setFilterApply}
        onReset={onReset}
      />
      <div>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            borderRadius: 1,
          }}
        >
          <Box sx={{ flexGrow: 1 }}>
            <PageTitle
              breadcrumb={false}
              title={"Invoices"}
              subTitle={"dwqdwq"}
            />
          </Box>
          {console.log(search, "dwqdwqd")}

          {tabsparentState != "Overall" && (
            <>
              <Box>
                {tabsparentState === "Vendor Invoices" && (
                  <>
                    <Box className={classes.paper}>
                      <IconButton
                        type="button"
                        sx={{ p: "10px" }}
                        aria-label="search"
                      >
                        <SearchIcon />
                      </IconButton>{" "}
                      <Box display={"flex"}>
                        <select
                          className="searchbar_select"
                          onChange={(e) => {
                            setSearchBy(e.target.value);
                            clearAll();
                          }}
                        >
                          <option value={"Customer Name"}>
                            Customer Name/ Location
                          </option>
                          <option value={"Invoice Number"}>
                            Invoice Number
                          </option>
                        </select>
                      </Box>
                      {searchBy === "Customer Name" ? (
                        <InputBase
                          data-testid="search-input"
                          sx={{ ml: 1, flex: 1 }}
                          onChange={(e) => setSearch(e.target.value)}
                          text="Search"
                          placeholder="Search by Name or Location"
                          onFocus={(e) => handleFocus(e)}
                          value={search}
                        />
                      ) : (
                        <InputBase
                          sx={{ ml: 1, flex: 1 }}
                          onChange={(e) => setSearch(e.target.value)}
                          text="Search"
                          placeholder="Search by Invoice Number"
                          value={search}
                        />
                      )}
                      <Box className="cursor_pointer" onClick={clearAll} mr={2}>
                        Clear
                      </Box>
                      {focus &&
                        searchBy === "Customer Name" &&
                        searchCustomers &&
                        searchCustomers?.searchCustomers && (
                          <div className="cus_search_drop">
                            {searchCustomers?.searchCustomers?.length > 0 &&
                              searchCustomers?.searchCustomers?.map((d, i) => (
                                <>
                                  <div
                                    className="search_items"
                                    onClick={() => handleSearchItemClick(d)}
                                  >
                                    {d?.name + " " + d?.internalName}
                                  </div>
                                </>
                              ))}
                          </div>
                        )}
                    </Box>
                  </>
                )}
                {tabsparentState === "End Customer Invoices" && (
                  <Box className={classes.paper}>
                    <IconButton
                      type="button"
                      sx={{ p: "10px" }}
                      aria-label="search"
                    >
                      <SearchIcon />
                    </IconButton>
                    <InputBase
                      sx={{ ml: 1, flex: 1 }}
                      onChange={(e) => setInvoiceSearch(e.target.value)}
                      placeholder="Search here by customer’s name, TDW Invoice no."
                      text="Search"
                    />
                  </Box>
                )}
              </Box>
              <Box className={classNames(classes.buttonContainer)}>
                <Button
                  onClick={(e) => handleClick(e, "calendar")}
                  className={classNames(classes.button)}
                  data-testId="cal-btn"
                >
                  <img src={Calendar}></img>
                </Button>
                <Button
                  data-testid="ftr-btn"
                  onClick={(e) => handleFilterClick(e, "filter")}
                  className={classNames(classes.button)}
                >
                  <img src={FilterIcon}></img>
                </Button>
              </Box>
            </>
          )}

          {(userRole === "admin" || userRole === "vendor") &&
            tabsparentState === "Vendor Invoices" && (
              <>
                {userRole === "admin" && (
                  <>
                    <Box className={classNames(classes.buttonContainer)}>
                      <Button
                        onClick={(e) => handleClick(e, "equipment")}
                        className={classNames(classes.button)}
                        data-testid="create-equip-btn"
                      >
                        <img src={Plus}></img> &nbsp;&nbsp;Create Equipment
                      </Button>
                    </Box>
                    <Box className={classNames(classes.buttonContainer)}>
                      <Button
                        ref={buttonRef}
                        onClick={(e) => handleClick(e, "customer")}
                        className={classNames(classes.button)}
                      >
                        <img src={Plus}></img> &nbsp;&nbsp;Create Customer
                      </Button>
                    </Box>
                    <Box className={classNames(classes.buttonContainer)}>
                      <Button
                        onClick={(e) => handleClick(e, "microInvoice")}
                        className={classNames(classes.button)}
                      >
                        <img src={Plus}></img> &nbsp;&nbsp;Create Invoice
                      </Button>
                    </Box>
                  </>
                )}
                {userRole === "vendor" && (
                  <Box className={classNames(classes.buttonContainer)}>
                    <Button
                      onClick={(e) => handleClick(e, "microInvoice")}
                      className={classNames(classes.button)}
                    >
                      <img src={Plus}></img> &nbsp;&nbsp;Create Invoice
                    </Button>
                  </Box>
                )}
              </>
            )}

          <Box className={classNames(classes.buttonContainer)}>
            {userRole === "admin" && tabsparentState === "Documents" && (
              <Button
                onClick={(e) => handleClick(e, "documents")}
                className={classNames(classes.button)}
              >
                <img src={Plus}></img> &nbsp;&nbsp;Create
              </Button>
            )}
          </Box>
          <Box className={classNames(classes.buttonContainer)}>
            {userRole === "admin" &&
              tabsparentState === "End Customer Invoices" && (
                <Button
                  onClick={(e) => handleClick(e, "invoices")}
                  className={classNames(classes.button)}
                >
                  <img src={Plus}></img> &nbsp;&nbsp;Create
                </Button>
              )}
          </Box>
        </Box>
        <CardContent
          search={search}
          tabsparentState={tabsparentState}
          vendorStatus={vendorStatus}
          customerInvoiceStatus={customerInvoiceStatus}
          classNames={classNames}
          classes={classes}
          vendorInvoiceData={vendorInvoiceData}
          invoicesData={invoicesData}
          image={open_invoice}
        />
        <Tabs
          tabColor={"#E9E9E9"}
          types={[
            // "Overall",
            // "End Customer Invoices",
            // "Vendor Invoices For Customer",
            "Vendor Invoices",
            // "Vendor Contracts",
            // "Documents",
          ]}
          onChange={handleChildChange}
          invoicesData={invoicesData}
          contractsData={contractsData}
          documentsData={documentsData}
          // customersData={allCustomersData}
          vendorInvoiceData={vendorInvoiceData}
          search={search}
          invoiceSearch={invoiceSearch}
          dateRange={date}
          setDate={setDate}
          loading={{
            vendorWorkOrdersLoading,
          }}
          filters={{ status, location, invoiceType, date }}
          setLocation={setLocation}
          setStatus={setStatus}
          setInvoiceType={setInvoiceType}
          location={location}
          status={status}
          invoiceType={invoiceType}
        />
      </div>
      {PopoverDisplay()}
    </>
  );
}
